import { useState } from "react";
import {
  FaHome,
  FaUser,
  FaHistory,
  FaWallet,
  FaPercentage,
  FaChartBar,
  FaHeadset,
  FaSignOutAlt,
  FaBars,
  FaExchangeAlt,
} from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const isActive = (path) => location.pathname === path;

  const handleNavigation = (path) => {
    navigate(path);
    setSidebarOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    window.location.href = "/login";
  };

  return (
    <>
      {/* Mobile top bar */}
      <div className="md:hidden sticky top-0 z-50 bg-white/70 dark:bg-slate-950/60 backdrop-blur-xl border-b border-black/5 dark:border-white/10 p-3">
        <button
          onClick={() => setSidebarOpen((v) => !v)}
          className="inline-flex h-10 w-10 items-center justify-center rounded-xl
                     border border-black/10 dark:border-white/10
                     bg-white/60 dark:bg-white/5 hover:bg-white dark:hover:bg-white/10 transition"
        >
          <FaBars />
        </button>
      </div>

      {/* Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/40 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed inset-y-0 left-0 z-50 w-72 transform transition-transform duration-200
          md:relative md:translate-x-0
          ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}
          border-r border-black/5 dark:border-white/10
          bg-white dark:bg-slate-950`}
      >
        {/* Brand header */}
        <div className="p-5 border-b border-black/5 dark:border-white/10">
          <div className="text-sm font-semibold text-slate-900 dark:text-white">Direct Money</div>
          <div className="text-xs text-slate-500 dark:text-slate-400">User dashboard</div>
        </div>

        {/* Nav */}
        <nav className="p-4 space-y-2 overflow-y-auto h-[calc(100vh-72px)]">
          <MenuItem icon={<FaHome />} label="Accueil" path="/user" active={isActive("/user")} onClick={handleNavigation} />
          <MenuItem icon={<FaUser />} label="Profil" path="/profile" active={isActive("/profile")} onClick={handleNavigation} />
          <MenuItem icon={<FaHistory />} label="Historique" path="/history" active={isActive("/history")} onClick={handleNavigation} />
          <MenuItem icon={<FaWallet />} label="Wallet" path="/wallet" active={isActive("/wallet")} onClick={handleNavigation} />
          <MenuItem icon={<FaExchangeAlt />} label="Transfert" path="/transaction" active={isActive("/transaction")} onClick={handleNavigation} />
          <MenuItem icon={<FaPercentage />} label="Commissions" path="/commissions" active={isActive("/commissions")} onClick={handleNavigation} />
          <MenuItem icon={<FaChartBar />} label="Statistiques" path="/stats" active={isActive("/stats")} onClick={handleNavigation} />
          <MenuItem icon={<FaHeadset />} label="Support" path="/support" active={isActive("/support")} onClick={handleNavigation} />

          <div className="pt-3 mt-3 border-t border-black/5 dark:border-white/10" />

          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 rounded-xl px-4 py-3
                       text-red-600 dark:text-red-400
                       hover:bg-red-50 dark:hover:bg-red-500/10 transition"
          >
            <FaSignOutAlt />
            <span className="text-sm font-medium">Déconnexion</span>
          </button>
        </nav>
      </aside>
    </>
  );
}

function MenuItem({ icon, label, active, onClick, path }) {
  return (
    <button
      onClick={() => onClick(path)}
      className={`w-full flex items-center gap-3 rounded-xl px-4 py-3 transition
        ${active
          ? "bg-slate-900 text-white dark:bg-white dark:text-slate-900 shadow-sm"
          : "text-slate-700 dark:text-slate-200 hover:bg-black/5 dark:hover:bg-white/10"
        }`}
    >
      <div className="text-base">{icon}</div>
      <span className="text-sm font-medium">{label}</span>
    </button>
  );
}
